import React from 'react';

const ConfirmationDialogContent = () => (
  <div>
    <div>You are changing tax currency for a BSM Enabled Company Code.
      All existing BSM balances must be cleared prior to changing tax currency.
      Only click &quot;Save&quot; if you confirm there are no existing BSM Balances
    </div>
  </div>
);

export default ConfirmationDialogContent;
